import styled, { css } from "styled-components";
import { breakpoints, maxBreakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const Slider = styled.div<{ isFullScreen: boolean; show: boolean }>`
    display: ${({ isFullScreen }) => (!isFullScreen ? "none" : "flex")};
    width: 100%;
    height: fit-content;
    padding: var(--spacing-2) var(--spacing-2) var(--spacing-3);
    visibility: ${({ show }) => (show ? "visible" : "hidden")};

    @media screen and (min-width: ${breakpoints.xl}) {
        padding-bottom: 0;
    }

    /* < breakpoint lg */
    @media screen and (max-width: ${maxBreakpoints.md}) {
        display: ${({ show }) => (!show ? "none" : "flex")};
    }

    ${({ isFullScreen }) =>
        isFullScreen &&
        css`
            padding: var(--spacing-5) var(--spacing-2);
            @media screen and (min-width: ${breakpoints.xl}) {
                padding-bottom: var(--spacing-5);
            }
        `};
`;

export const SliderPositionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 var(--spacing-2);
`;

export const SliderPosition = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 30px;
    height: 6px;
    margin: 0 clamp(0px, 10px, 1%);
    cursor: pointer;
`;

export const SliderPositionBar = styled.div<{ active: boolean }>`
    width: 100%;
    min-width: ${({ active }) => (active ? "30px" : "3px")};
    max-width: 50px;
    height: 4px;
    background: ${({ active }) => (active ? "var(--color-black)" : "var(--color-platinum-light)")};
    border-radius: 2px;
    transition: all 0.2s;
`;

export const SliderButtons = styled.div`
    display: flex;
    width: fit-content;
    padding: 0 var(--spacing-2);
    gap: calc(var(--spacing-1) / 2);

    &[hidden] {
        display: none;
    }
`;
